import { PowerUpType } from "../../data/enums";
import { PowerUpBase } from "./PowerUpBase";

export class FishFrenzyPowerUp extends PowerUpBase {
    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y, "powerup-frenzy", PowerUpType.FishFrenzy, 20000);
    }
}
